/* HOME-VIDEO-CAROUSEL-001 — center-active infinite rail (HP community, no scale) */
(function () {
  "use strict";

  function initRoot(root) {
    if (!root || root.getAttribute("data-pvc-ready") === "1") return;
    var viewport = root.querySelector("[data-pvc-viewport]");
    var track = root.querySelector("[data-pvc-track]");
    if (!viewport || !track) return;
    root.setAttribute("data-pvc-ready", "1");

    var reduce = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    var slideAutoplay = root.getAttribute("data-autoplay") === "true";
    var intervalMs = parseInt(root.getAttribute("data-autoplay-interval"), 10);
    if (!intervalMs || intervalMs < 1200) intervalMs = 8000;

    var reals = Array.prototype.slice.call(track.querySelectorAll("[data-pvc-card]"));
    var N = reals.length;
    if (N === 0) return;

    if (N >= 2) {
      var cloneLast = reals[N - 1].cloneNode(true);
      var cloneFirst = reals[0].cloneNode(true);
      cloneLast.classList.add("is-clone");
      cloneFirst.classList.add("is-clone");
      cloneLast.classList.remove("is-active");
      cloneFirst.classList.remove("is-active");
      cloneLast.removeAttribute("data-pvc-card");
      cloneFirst.removeAttribute("data-pvc-card");
      cloneLast.setAttribute("aria-hidden", "true");
      cloneFirst.setAttribute("aria-hidden", "true");
      track.insertBefore(cloneLast, reals[0]);
      track.appendChild(cloneFirst);
    }

    var slides = Array.prototype.slice.call(track.querySelectorAll(".pvc-card"));
    var active = N >= 2 ? Math.floor(N / 2) : 0;
    var ti = N >= 2 ? active + 1 : 0;
    var playing = null;
    var inView = false;
    var animating = false;
    var playToken = 0;
    var retryTimer = null;
    var slideTimer = null;
    var animTimer = null;
    var hoverPaused = false;
    var suppressClick = false;

    function videoOf(slide) {
      return slide ? slide.querySelector("video") : null;
    }

    function pauseAll(except) {
      playToken += 1;
      if (retryTimer) {
        clearTimeout(retryTimer);
        retryTimer = null;
      }
      slides.forEach(function (sl) {
        var v = sl.querySelector("video");
        if (v && v !== except) {
          v.autoplay = false;
          v.removeAttribute("autoplay");
          try {
            v.pause();
          } catch (e) {}
        }
      });
      if (!except) playing = null;
    }

    function center(idx, anim) {
      var el = slides[idx];
      if (!el) return;
      if (!anim) track.classList.add("no-anim");
      var x = viewport.clientWidth / 2 - (el.offsetLeft + el.offsetWidth / 2);
      track.style.transform = "translateX(" + x + "px)";
      if (!anim) {
        void track.offsetWidth;
        track.classList.remove("no-anim");
      }
    }

    function mark() {
      slides.forEach(function (sl) {
        sl.classList.remove("is-active");
        sl.removeAttribute("aria-current");
      });
      if (slides[ti]) {
        slides[ti].classList.add("is-active");
        if (!slides[ti].classList.contains("is-clone")) {
          slides[ti].setAttribute("aria-current", "true");
        }
      }
    }

    function ensureSrc(v, mode) {
      if (!v) return;
      var src = v.getAttribute("data-src");
      if (!src) return;
      var preload = mode || "none";
      function apply(el) {
        if (!el) return;
        if (el.getAttribute("src") !== src) {
          el.preload = preload;
          el.src = src;
        } else if (mode === "auto") {
          el.preload = "auto";
        }
      }
      apply(v);
      slides.forEach(function (sl) {
        var cv = videoOf(sl);
        if (cv && cv !== v && cv.getAttribute("data-src") === src) apply(cv);
      });
    }

    function warmNeighbors(slideIdx) {
      function run() {
        if (slides[slideIdx - 1]) ensureSrc(videoOf(slides[slideIdx - 1]));
        if (slides[slideIdx + 1]) ensureSrc(videoOf(slides[slideIdx + 1]));
      }
      if (window.requestIdleCallback) {
        requestIdleCallback(run, { timeout: 1200 });
      } else {
        setTimeout(run, 280);
      }
    }

    function armVideo(v) {
      v.defaultMuted = true;
      v.muted = true;
      v.setAttribute("muted", "");
      v.playsInline = true;
      v.setAttribute("playsinline", "");
      v.setAttribute("webkit-playsinline", "");
      v.autoplay = true;
      v.setAttribute("autoplay", "");
    }

    function playCenter() {
      if (!inView || document.hidden) {
        pauseAll();
        return;
      }
      var slide = slides[ti];
      if (!slide || slide.classList.contains("is-clone")) return;
      var v = slide.querySelector("video");
      if (!v) {
        pauseAll();
        return;
      }
      if (playing === v && !v.paused) return;
      pauseAll(v);
      ensureSrc(v, "auto");
      var token = playToken;
      var tries = 0;
      armVideo(v);
      function attempt() {
        if (token !== playToken || !inView || document.hidden || slides[ti] !== slide) return;
        tries += 1;
        var pr;
        try {
          pr = v.play();
        } catch (e) {}
        if (pr && pr.catch) {
          pr.catch(function () {
            if (token === playToken && tries < 8) retryTimer = setTimeout(attempt, 280);
          });
        } else if (v.paused && tries < 8) {
          retryTimer = setTimeout(attempt, 280);
        }
      }
      function afterReady() {
        if (token !== playToken) return;
        if (v.paused) attempt();
        warmNeighbors(ti);
      }
      v.addEventListener(
        "playing",
        function () {
          if (v.getAttribute("poster")) v.removeAttribute("poster");
        },
        { once: true }
      );
      if (v.readyState < 2) {
        v.addEventListener("canplay", afterReady, { once: true });
        v.addEventListener("loadeddata", afterReady, { once: true });
      } else {
        afterReady();
      }
      attempt();
      playing = v;
    }

    function settle() {
      animating = false;
      if (animTimer) {
        clearTimeout(animTimer);
        animTimer = null;
      }
      var fromVid = videoOf(slides[ti]);
      var wrapped = false;
      if (N >= 2) {
        if (ti === 0) {
          ti = N;
          active = N - 1;
          wrapped = true;
        } else if (ti === N + 1) {
          ti = 1;
          active = 0;
          wrapped = true;
        }
      }
      mark();
      center(ti, false);
      var toVid = videoOf(slides[ti]);
      if (wrapped && fromVid && toVid && fromVid !== toVid) {
        try {
          toVid.currentTime = fromVid.currentTime;
        } catch (e) {}
      }
      playCenter();
    }

    function go(dir) {
      if (animating || N < 2) return;
      ti += dir;
      active = (active + dir + N) % N;
      mark();
      ensureSrc(videoOf(slides[ti]), "auto");
      if (reduce) {
        center(ti, false);
        settle();
        return;
      }
      animating = true;
      center(ti, true);
      if (animTimer) clearTimeout(animTimer);
      animTimer = setTimeout(function () {
        if (animating) settle();
      }, 520);
    }

    function goTo(realIndex) {
      if (N < 2 || realIndex === active || animating) return;
      ti = N >= 2 ? realIndex + 1 : realIndex;
      active = realIndex;
      mark();
      ensureSrc(videoOf(slides[ti]), "auto");
      if (reduce) {
        center(ti, false);
        settle();
        return;
      }
      animating = true;
      center(ti, true);
      if (animTimer) clearTimeout(animTimer);
      animTimer = setTimeout(function () {
        if (animating) settle();
      }, 520);
    }

    function stopSlideTimer() {
      if (slideTimer) {
        clearInterval(slideTimer);
        slideTimer = null;
      }
    }

    function startSlideTimer() {
      stopSlideTimer();
      if (!slideAutoplay || reduce || N < 2 || hoverPaused || !inView || document.hidden) return;
      slideTimer = setInterval(function () {
        if (!hoverPaused && inView && !document.hidden && !animating) go(1);
      }, intervalMs);
    }

    track.addEventListener("transitionend", function (e) {
      if (e.target === track && e.propertyName === "transform") settle();
    });

    reals.forEach(function (el, i) {
      el.addEventListener("click", function () {
        if (suppressClick) {
          suppressClick = false;
          return;
        }
        if (i !== active) goTo(i);
        else playCenter();
      });
    });

    slides.forEach(function (el, i) {
      if (!el.classList.contains("is-clone")) return;
      el.addEventListener("click", function () {
        if (suppressClick) {
          suppressClick = false;
          return;
        }
        go(i < ti ? -1 : 1);
      });
    });

    var sx = null;
    var sy = null;
    var dx = 0;
    var dy = 0;
    var dragging = false;
    var baseX = 0;
    var horiz = false;

    function curX() {
      var m = /translateX\(([-0-9.]+)px\)/.exec(track.style.transform);
      return m ? parseFloat(m[1]) : 0;
    }

    viewport.addEventListener("pointerdown", function (e) {
      if (animating || e.button === 2) return;
      hoverPaused = true;
      stopSlideTimer();
      inView = true;
      playCenter();
      sx = e.clientX;
      sy = e.clientY;
      baseX = curX();
      dragging = true;
      horiz = false;
      dx = 0;
      dy = 0;
      viewport.classList.add("is-dragging");
      try {
        viewport.setPointerCapture(e.pointerId);
      } catch (er) {}
      track.classList.add("no-anim");
    });

    viewport.addEventListener("pointermove", function (e) {
      if (!dragging) return;
      dx = e.clientX - sx;
      dy = e.clientY - sy;
      if (!horiz) {
        if (Math.abs(dx) > Math.abs(dy) && Math.abs(dx) > 6) horiz = true;
        else if (Math.abs(dy) > 10) {
          dragging = false;
          viewport.classList.remove("is-dragging");
          track.classList.remove("no-anim");
          return;
        }
      }
      if (horiz) {
        if (e.cancelable) e.preventDefault();
        track.style.transform = "translateX(" + (baseX + dx) + "px)";
      }
    });

    function endDrag(e) {
      if (!dragging) return;
      dragging = false;
      viewport.classList.remove("is-dragging");
      try {
        if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId);
      } catch (er) {}
      track.classList.remove("no-anim");
      var cw = (slides[ti] && slides[ti].offsetWidth) || 0;
      var thr = Math.max(24, cw * 0.12);
      if (horiz && Math.abs(dx) > 8) suppressClick = true;
      if (horiz && Math.abs(dx) > thr) go(dx < 0 ? 1 : -1);
      else center(ti, true);
      sx = null;
      sy = null;
      dx = 0;
      dy = 0;
      horiz = false;
    }

    viewport.addEventListener("pointerup", endDrag);
    viewport.addEventListener("pointercancel", endDrag);

    root.addEventListener("mouseenter", function () {
      hoverPaused = true;
      stopSlideTimer();
    });
    root.addEventListener("mouseleave", function () {
      hoverPaused = false;
      startSlideTimer();
    });

    root.setAttribute("tabindex", "0");
    root.addEventListener("keydown", function (e) {
      if (e.key === "ArrowLeft") {
        e.preventDefault();
        go(-1);
      } else if (e.key === "ArrowRight") {
        e.preventDefault();
        go(1);
      }
    });

    if ("IntersectionObserver" in window) {
      new IntersectionObserver(
        function (ents) {
          ents.forEach(function (en) {
            inView = en.isIntersecting;
            if (inView) {
              center(ti, false);
              playCenter();
              startSlideTimer();
            } else {
              pauseAll();
              stopSlideTimer();
            }
          });
        },
        { threshold: 0, rootMargin: "240px 0px" }
      ).observe(viewport);
    } else {
      inView = true;
    }

    document.addEventListener("visibilitychange", function () {
      if (document.hidden) {
        pauseAll();
        stopSlideTimer();
      } else if (inView) {
        playCenter();
        startSlideTimer();
      }
    });

    window.addEventListener("resize", function () {
      center(ti, false);
    });

    mark();
    center(ti, false);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        center(ti, false);
      });
    });
    window.addEventListener("load", function () {
      center(ti, false);
    });

    function visibleNow() {
      var r = viewport.getBoundingClientRect();
      var h = window.innerHeight || document.documentElement.clientHeight;
      return r.bottom > 0 && r.top < h;
    }

    function kick() {
      if (document.hidden || !visibleNow()) return;
      var cv = slides[ti] && slides[ti].querySelector("video");
      if (cv && !cv.paused) return;
      inView = true;
      playCenter();
      startSlideTimer();
    }

    setTimeout(kick, 60);
    window.addEventListener("scroll", kick, { passive: true });
    window.addEventListener("load", kick);
  }

  function boot(scope) {
    var root = scope || document;
    var nodes = root.querySelectorAll ? root.querySelectorAll("[data-pvc]") : [];
    if (root !== document && root.getAttribute && root.getAttribute("data-pvc") != null) {
      initRoot(root);
    }
    Array.prototype.forEach.call(nodes, initRoot);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      boot(document);
    });
  } else {
    boot(document);
  }

  document.addEventListener("shopify:section:load", function (e) {
    if (e && e.target) boot(e.target);
  });
})();
